var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraKyc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.72577 0.0121312C6.86743 0.16093 6.47435 0.494624 5.60825 1.80992L4.98514 2.75614L3.70821 2.77135C1.82517 2.79379 1.22093 3.07763 0.714225 4.1778C0.487012 4.67105 0.492208 4.53809 0.504946 9.52792L0.516668 14.1229L0.623301 14.4153C0.888142 15.1416 1.43498 15.6604 2.21637 15.9268C2.4237 15.9974 2.71597 16 10.5 16C18.284 16 18.5763 15.9974 18.7836 15.9268C19.565 15.6604 20.1119 15.1416 20.3767 14.4153L20.4833 14.1229L20.4951 9.52792C20.5078 4.53809 20.513 4.67105 20.2858 4.1778C19.7791 3.07763 19.1748 2.79379 17.2918 2.77135L16.0149 2.75614L15.3918 1.80992C14.596 0.601462 14.34 0.353216 13.6259 0.0976174L13.3719 0.00673452L10.5977 0.000946853C9.07186 -0.00222075 7.77949 0.00282392 7.72577 0.0121312ZM11.2935 3.35207C15.3873 3.96463 17.2744 8.81744 14.6758 12.0503C11.9077 15.4941 6.27738 14.2064 5.271 9.89943C4.40712 6.20217 7.54474 2.79114 11.2935 3.35207ZM18.1062 4.85641C18.5439 5.11314 18.5507 5.74788 18.1189 6.03914C17.9879 6.12752 17.9618 6.13002 17.2961 6.11825L16.6087 6.10613L16.4612 5.99343C16.0751 5.69841 16.1272 5.06113 16.5551 4.84495C16.8327 4.70472 17.8605 4.71231 18.1062 4.85641ZM10.1288 5.68171C7.6166 6.08626 6.61115 9.02689 8.38584 10.7793C10.3444 12.7133 13.6532 11.2328 13.4971 8.49231C13.4006 6.79784 11.7501 5.4206 10.1288 5.68171Z",
    fill: "#161313"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraKyc);
export default __webpack_public_path__ + "static/media/cameraKyc.0fc127c3dade762f427be63a863acac7.svg";
export { ForwardRef as ReactComponent };